/**
 * Nút mở dialog chia sẻ — variant mặc định hoặc nút hành động trang chi tiết.
 */
import { useState } from 'react';
import { TEXT } from '../../shared/languages';
import { ShareDialog } from './ShareDialog';

const ShareIcon = () => (
  <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M16 3v18M16 3l-6 6M16 3l6 6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 19v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8" strokeLinecap="round" />
  </svg>
);

export const ShareButton = ({ title, url, variant = 'default' }) => {
  const [isShareOpen, setIsShareOpen] = useState(false);
  const shareUrl = url || window.location.href;
  const t = TEXT.share;

  if (variant === 'detail') {
    return (
      <>
        <button type="button" className="detail-action-btn" onClick={() => setIsShareOpen(true)}>
          <ShareIcon />
          {t.button}
        </button>
        <ShareDialog
          isOpen={isShareOpen}
          onClose={() => setIsShareOpen(false)}
          title={title}
          url={shareUrl}
        />
      </>
    );
  }

  return (
    <>
      <div className="share-button-wrap">
        <button type="button" className="button ghost small" onClick={() => setIsShareOpen(true)}>
          {t.button}
        </button>
      </div>
      <ShareDialog
        isOpen={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        title={title}
        url={shareUrl}
      />
    </>
  );
};
